import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Input,
  Modal,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React from "react";
import { FaNetworkWired } from "react-icons/fa";
import { useOficinas } from "../hooks/useOficinas";
import GifLoader from "../components/ui/gifLoader";
import Select, { components } from "react-select";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: 2,
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
};

export const OficinasView = () => {
  const {
    state,
    loader,
    columns,
    options,
    handleInputChange,
    handleOpenModal,
    handleCloseModal,
    handleDeleteOficina,
    handleCloseModalDel,
    handleSelectChange,
    handleCreate,
    handleSelectMunicipiosChange,
  } = useOficinas();
  const {
    oficinas,
    municipios,
    municipioSelected,
    municipioFilter,
    showModal,
    showModalDel,
    oficina,
    claveOficina,
    isEditing,
    oficinaDel
  } = state;

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-css-class">No Hay Resultados</span>
      </components.NoOptionsMessage>
    );
  };

  return (
    <>
      {loader && <GifLoader />}
      <div className="container my-1">
        <div className="border-bottom--guinda text-big mb-2 text-bold">
          Oficinas
        </div>
      </div>
      <div
        className="container my-1"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <FormControl sx={{ minWidth: "40%" }}>
          <Select
            style={{ zIndex: 110 }}
            options={municipios}
            placeholder="Seleccione municipio"
            getOptionValue={(options) => options.IDENTIFICADOR}
            getOptionLabel={(options) => options.DESCRIPCION}
            onChange={handleSelectMunicipiosChange}
            components={{ NoOptionsMessage }}
            value={municipioFilter}
          />
        </FormControl>
        <Button
          variant="contained"
          onClick={handleOpenModal}
          sx={{
            backgroundColor: "var(--main-color-vino)",
            "&:hover": {
              backgroundColor: "var(--main-color-vino)",
              transform: "scale(1.005)",
              boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
            },
          }}
        >
          <FaNetworkWired style={{ marginRight: "8px" }} />
          Agregar
        </Button>
      </div>
      <div className="container mt-3 mb-5 mui-datatable-small">
        <MUIDataTable
          title={"Listado de oficinas"}
          data={oficinas}
          columns={columns}
          options={options}
        />
      </div>
      <Modal
        open={showModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="container">
            <div className="border-bottom--guinda text-big mb-4 text-bold">
              {isEditing ? "Editar" : "Agregar"} oficina
            </div>
          </div>
          <div className="container my-3">
            <FormControl sx={{ width: 1, textAlign: "center" }} required>
              <Input
                id="my-input"
                aria-describedby="my-helper-text"
                name="claveOficina"
                value={claveOficina}
                onChange={handleInputChange}
                sx={{ textAlign: "center" }}
              />
              <FormHelperText sx={{ textAlign: "center" }} id="my-helper-text">
                Ingresa la clave de oficina.
              </FormHelperText>
            </FormControl>
          </div>
          <div className="container my-3">
            <FormControl sx={{ width: 1 }} required>
              <Input
                id="my-input"
                aria-describedby="my-helper-text"
                name="oficina"
                value={oficina}
                onChange={handleInputChange}
              />
              <FormHelperText sx={{ textAlign: "center" }} id="my-helper-text">
                Ingresa la oficina.
              </FormHelperText>
            </FormControl>
          </div>
          <div className="container my-1">
            <FormControl sx={{ minWidth: "100%", maxWidth: "100%" }}>
              <Select
                style={{ zIndex: 110 }}
                options={municipios.filter((municipio) => {
                  return municipio.IDENTIFICADOR !== null;
                })}
                placeholder="Seleccione municipio"
                getOptionValue={(options) => options.IDENTIFICADOR}
                getOptionLabel={(options) => options.DESCRIPCION}
                onChange={handleSelectChange}
                components={{ NoOptionsMessage }}
                value={municipioSelected}
              />
              <FormHelperText>Selecciona un municipio.</FormHelperText>
            </FormControl>
          </div>
          <div
            className="container my-3"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              onClick={handleCreate}
              sx={{
                backgroundColor: "var(--main-color-vino)",
                "&:hover": {
                  backgroundColor: "var(--main-color-vino)",
                  transform: "scale(1.005)",
                  boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
                },
              }}
            >
              {isEditing ? "Actualizar" : "Agregar"}
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={showModalDel}
        onClose={handleCloseModalDel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="container">
            <div
              style={{ textAlign: "center" }}
              className="border-bottom--guinda text-big mb-4 text-bold"
            >
              ¿Deseas eliminar la oficina {oficinaDel.DESCRIPCION}?
            </div>
          </div>
          <div
            className="container my-3"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              onClick={handleCloseModalDel}
              sx={{
                backgroundColor: "var(--main-color-vino)",
                "&:hover": {
                  backgroundColor: "var(--main-color-vino)",
                  transform: "scale(1.005)",
                  boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
                },
                marginRight: 3
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={()=>handleDeleteOficina(oficinaDel.ID)}
              sx={{
                backgroundColor: "var(--main-color-vino)",
                "&:hover": {
                  backgroundColor: "var(--main-color-vino)",
                  transform: "scale(1.005)",
                  boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
                },
              }}
            >
              Eliminar
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
